import type { ReactNode } from "react";
import styles from "./Card.module.css";

type CardProps = {
  eyebrow?: string;
  title: string;
  body?: ReactNode;
  bullets?: string[];
  children?: ReactNode;
  tone?: "default" | "accent";
};

export default function Card({
  eyebrow,
  title,
  body,
  bullets,
  children,
  tone = "default",
}: CardProps) {
  return (
    <article className={[styles.card, tone === "accent" ? styles.accent : ""].join(" ")}>
      {eyebrow ? <span className="eyebrow">{eyebrow}</span> : null}
      <h3 className={styles.title}>{title}</h3>
      {body ? <p className={styles.body}>{body}</p> : null}
      {bullets && bullets.length > 0 ? (
        <ul className={styles.bullets}>
          {bullets.map((b) => (
            <li key={b}>{b}</li>
          ))}
        </ul>
      ) : null}
      {children}
    </article>
  );
}
